import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { MaintenanceState } from '@/app/maintenance/store/state'

export const getters: GetterTree<MaintenanceState, RootState> = {}
